import React, { useEffect, useMemo } from "react"
// import FeaturedProductsItem from "@app/components/Sections/FeaturedProducts/FeaturedProductsItem"
import CartUpsellProductCards from "../Sections/CartUpsellProductCards/CartUpsellProductCards"
import { useShopify } from "../../hooks/useShopify"
import { useCheckoutContext } from "../../hooks/useCheckout"
import { useCore } from "../../hooks/useCore"
import { useLazyQuery } from "@apollo/client"
import { Swiper, SwiperSlide } from "swiper/react"
import SwiperCore, { Pagination } from "swiper"
import styled from "@emotion/styled"
import "swiper/swiper.min.css"
import "swiper/components/pagination/pagination.min.css"

const SwiperWrapper = styled.div`
  padding-top: 14px;
`
const SwiperSlider = styled(Swiper)`
  padding-left: 24px;
  padding-bottom: 48px;
  .swiper-container {
    overflow-y: visible !important;
  }
  .swiper-pagination {
    bottom: 14px !important;
  }
  .swiper-pagination-bullet {
    background: #e6e6e6;
  }
  .swiper-pagination-bullet-active {
    background: #000000;
  }
`

SwiperCore.use([Pagination])

type Props = {
  isExpanded: boolean
}

const CartRecommended: React.FC<Props> = ({ isExpanded }) => {
  const {
    graphql: {
      queries: { GET_CART_RECOMMENDATIONS },
    },
  } = useCore()
  const { checkout } = useCheckoutContext()
  const { productNormaliser } = useShopify()

  const ids = useMemo(
    () =>
      checkout?.lineItems?.map(
        ({
          variant: {
            product: { id },
          },
        }: any) => id
      ),
    [checkout?.lineItems]
  )

  const [getRecommendations, { data: items, called, error }] = useLazyQuery(GET_CART_RECOMMENDATIONS(ids), {
    fetchPolicy: "cache-and-network",
    nextFetchPolicy: "cache-first",
    variables: {
      firstImages: 10,
      firstVariants: 1,
    },
  })

  if (error) console.error(error)

  // flatten product objects, remove duplicates, randomise and limit to 9 products
  const recommendations = useMemo(
    () =>
      items
        ? []
            .concat(...Object.values(items)?.map((products: any) => products?.map(productNormaliser)))
            .filter((v: any, i: number, a: any) => a.findIndex((t: any) => t.id === v.id) === i)
            .sort(() => Math.random() - 0.5)
            .slice(0, 6)
        : [],
    [items, productNormaliser]
  )

  useEffect(() => {
    if (!ids || called) return
    getRecommendations()
  }, [ids, called])

  return recommendations?.length ? (
    <SwiperWrapper>
      <SwiperSlider
        init={isExpanded}
        navigation={false}
        spaceBetween={16}
        slidesPerView={1.25}
        lazy={true}
        preloadImages={true}
        pagination={{
          clickable: true,
        }}
        autoHeight={true}
      >
        {recommendations?.map((item, index) => (
          <SwiperSlide key={index}>
            <CartUpsellProductCards key={item?.id?.toString()} index={index + 1} item={item} />
          </SwiperSlide>
        ))}
      </SwiperSlider>
    </SwiperWrapper>
  ) : null
}

export default React.memo(CartRecommended)
